import { Icon } from "@ospweb/sdk-ui";
import Image from "next/image";
import { AgentItem } from "@/src/hooks";
import { proxyImage } from "@/src/utils/imageProxy";

export const Hot = ({ data }: { data: AgentItem }) => {
  return (
    <div className="grid grid-cols-1 gap-3 px-4 py-3 rounded-xl cursor-pointer">
      <div className="flex items-center justify-between h-full gap-1">
        <div className="flex items-center gap-2">
          <Image
            src={proxyImage(data.logo || "")}
            alt={data.name || "edgen"}
            width={32}
            height={32}
            className="rounded-full w-8 h-8"
          />
          <div className="flex flex-col">
            <div className="body_medium_m text-content_primary line-clamp-1 md:max-w-[80px] max-w-[200px]">
              {data.token_symbol}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-1">
          <Icon name="hot" size={16} className="text-content_accent3_primary" />
          <div className="body_medium_m text-content_primary">
            {data?.eval ?? 0}
          </div>
        </div>
      </div>
    </div>
  );
};
